(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignupValidation {
    constructor(formElement) {
      this.form = formElement;
      this.blockId = this.form.querySelector('[id^="EmailInput-"]').id.split('-')[1];
      this.emailInput = this.form.querySelector(`#EmailInput-${this.blockId}`);
      this.checkbox = this.form.querySelector('.email-signup__checkbox');
      this.emailError = this.form.querySelector(`#Email-signup__email-error-${this.blockId}`);
      this.checkboxError = this.form.querySelector(`#Email-signup__checkbox-error-${this.blockId}`);

      this.init();
    }

    init() {
      // Prevent default HTML5 validation
      this.form.setAttribute('novalidate', 'novalidate');

      // Bind handler so we can remove it later
      this.boundHandleSubmit = (e) => this.handleSubmit(e);

      // Add submit event listener with capture: true to run BEFORE other handlers like reCAPTCHA
      this.form.addEventListener('submit', this.boundHandleSubmit, true);

      // Add input event listeners to clear errors
      this.emailInput.addEventListener('input', () => {
        this.hideError(this.emailError);
        this.emailInput.classList.remove('error');
      });
      this.checkbox.addEventListener('change', () => {
        this.hideError(this.checkboxError);
        this.checkbox.classList.remove('error');
      });
    }

    handleSubmit(e) {
      // Hide all errors first
      this.hideError(this.emailError);
      this.hideError(this.checkboxError);
      this.emailInput.classList.remove('error');
      this.checkbox.classList.remove('error');

      let isValid = true;

      // Validate email
      if (!this.validateEmail()) {
        this.showError(this.emailError);
        this.emailInput.classList.add('error');
        isValid = false;
      }

      // Validate checkbox
      if (!this.validateCheckbox()) {
        this.showError(this.checkboxError);
        this.checkbox.classList.add('error');
        isValid = false;
      }

      // If validation fails, stop ALL event handlers including reCAPTCHA
      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }

    validateEmail() {
      const email = this.emailInput.value.trim();

      if (!email) {
        return false;
      }

      // Basic email regex validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    validateCheckbox() {
      return this.checkbox.checked;
    }

    showError(errorElement) {
      if (errorElement) {
        errorElement.style.display = 'flex';
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    hideError(errorElement) {
      if (errorElement) {
        errorElement.style.display = 'none';
      }
    }
  }

  // Initialize validation for all email signup forms on the page
  document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.email-signup__form');
    forms.forEach(form => {
      new EmailSignupValidation(form);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
